import React from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import ShopCard from "./ShopCard";
import { useTranslation } from "react-i18next";
import "swiper/css";
import "swiper/css/navigation";

const FlashSalesOne = ({ shops = [] }) => {
  const { t } = useTranslation();

  return (
    <section className="pt-80">
      <div className="container">
        {/* Section Header */}
        <div className="section-heading mb-10">
          <div className="flex-between flex-wrap gap-8">
            <h5 className="mb-0">{t("topRatedShops")}</h5>
            <Link
              to="/shops"
              className="btn btn-main-two fw-medium d-inline-flex align-items-center rounded-pill gap-8"
            >
              {t("visitAllShops")}
              <span className="icon text-xl d-flex">
                <i className="ph ph-arrow-right"></i>
              </span>
            </Link>
          </div>
        </div>

        {/* Swiper Slider */}
        {shops.length > 0 && (
          <Swiper
            modules={[Navigation, Autoplay]}
            spaceBetween={20}
            slidesPerView={3}
            navigation={{
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            }}
            autoplay={{ delay: 3000 }}
            speed={1000}
            loop={true}
            breakpoints={{
              1200: { slidesPerView: 2 },
              768: { slidesPerView: 2 },
              576: { slidesPerView: 1 },
            }}
          >
            {shops.map((item) => (
              <SwiperSlide key={item._id}>
                <div className="shop-card-wrapper">
                  <ShopCard item={item} className="col-12" />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        )}
        {shops.length === 0 && <div className="text-center">
              <img className="" src="/assets/images/grey.png" alt="" />
              <p className="">The data is not available for the region you are from.</p>
            </div>}
      </div>
    </section>
  );
};

export default FlashSalesOne;
